import { css, cx } from "@emotion/css";
import { ValueRem } from "./Value";

const LayoutCol: React.FC<{
  className?: Parameters<typeof cx>[0];
  gap?: ValueRem;
  alignX?: "center" | "start" | "end";
  alignText?: "center" | "left" | "right";
  alignY?: "center" | "start" | "end";
}> = (props) => {
  return (
    <div
      className={cx(
        css`
          label: LayoutCol;
          display: flex;
          flex-direction: column;
          gap: ${props.gap};
          align-items: ${props.alignX};
          justify-content: ${props.alignY};
          text-align: ${props.alignText};
        `,
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

export default LayoutCol;
